import { render, staticRenderFns } from "./associatedData.vue?vue&type=template&id=ae411466&scoped=true&"
import script from "./associatedData.vue?vue&type=script&setup=true&lang=js&"
export * from "./associatedData.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./associatedData.vue?vue&type=style&index=0&id=ae411466&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae411466",
  null
  
)

export default component.exports